import { Box } from '@mantine/core';

import { Navigation } from '../navigation/navigation';
import classes from './app-shell.module.css';

export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <Box className={classes.container}>
      <Navigation />
      <Box className={classes.content} data-app-scroll>
        {children}
      </Box>
    </Box>
  );
}
